<template>
  <div class="announcement-box" :class="showTopLine">
    <div class="announcement">
      <!-- <div class="announcement-tag">公告</div> -->
      <component :is="announcementIconName" class="announcement-icon" />
      <div class="announcement-content-title">系统维护中，评论功能暂不开放，敬请谅解</div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, toRefs, computed } from 'vue';
import { constant } from '@cpc/comment-sdk-common';
import { useGlobalState } from '@cpc/comment-sdk-core-comment';
import Announcement from './AnnouncementIcon/announcement.vue';
import AnnouncementDark from './AnnouncementIcon/announcementDark.vue';

export default defineComponent({
  name: 'Announcement',
  setup() {
    const { CommentStatus, PageType } = constant;
    const { commentStatus, pageType, isNightMode } = toRefs(useGlobalState());

    const showTopLine = computed(() => {
      return {
        'top-line': pageType.value === PageType.DEFAULT,
      };
    });

    const date = new Date();
    const announceTime =
      date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    const announcementIconName = computed(() => {
      return isNightMode.value ? AnnouncementDark : Announcement;
    });

    return {
      showTopLine,
      announceTime,

      commentStatus,
      CommentStatus,
      announcementIconName,
    };
  },
});
</script>

<style scoped lang="scss">
@import '../assets/css/styling-mixin.scss';

.announcement-box {
  overflow: hidden;
}

.announcement {
  border-radius: 36px;
  padding: 24px 48px 24px 36px;
  margin: 24px 0;
  display: flex;
  flex-direction: row;
  align-items: center;

  position: relative;
  background-color: rgba(0, 0, 0, 0.04);
  @include os-browser-styling(13, 'not-video') {
    background-color: rgba(250, 250, 250, 1);
  }
  @include os-browser-styling('', 'video') {
    margin: 0 48px;
  }

  // &::after {
  //   position: absolute;
  //   content: '';
  //   width: 300%;
  //   height: 300%;
  //   border: 2px solid #e8e8e8;
  //   border-radius: 72px;
  //   left: 0;
  //   top: 0;
  //   transform: scale(0.3333);
  //   transform-origin: 0 0;
  //   z-index: -1;
  // }
}
.announcement-icon {
  width: 60px;
  height: 60px;
  margin-right: 24px;
}

.announcement-content-title {
  font-size: 36px;
  color: rgba(0, 0, 0, 0.54);
}

.top-line::before {
  margin-bottom: 60px;
}

html[data-theme='dark'] {
  .announcement {
    background-color: rgba(192, 192, 192, 0.3);
  }
  .announcement-content-title {
    color: rgba(255, 255, 255, 0.54);
  }
}
</style>
